import { FunctionComponent, useState } from "react";
import Label from "../../../Label";
import classNames from "classnames";
import "./Tags.scss";
type Props = {
  tags: string[];
  addTag: (tag: string) => void;
  removeTag: (tag: string) => void;
};

const Tags: FunctionComponent<Props> = ({ tags, addTag, removeTag }) => {
  const [tag, setTag] = useState<string>();

  const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    setTag(value);
  };

  const handleAddTag = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (tag) {
      addTag(tag);
      setTag("");
    }
  };

  const handleRemoveTag = (tag: string) => {
    removeTag(tag);
  };

  return (
    <div>
      <div className="productForm__inputContainer">
        <Label
          tag="label"
          htmlFor="tag"
          className="label__grey"
          style={{ fontSize: "14px" }}
        >
          Tag
        </Label>
        <input
          type="text"
          id="tag"
          value={tag}
          name="tag"
          className=""
          placeholder="Ingrese tag"
          onChange={handleInputChange}
        ></input>
        <div className="buttonsContainer">
          <button
            onClick={handleAddTag}
            type="submit"
            className={classNames("buttonsContainer__button")}
          >
            Agregar
          </button>
        </div>
      </div>
      <ul className="tag__list">
        {tags?.map((tag, i) => {
          return (
            <li className="tag__item" key={i}>
              <p className="tag__item--text">{tag}</p>
              <span
                className="tag__item--close"
                onClick={() => handleRemoveTag(tag)}
              >
                x
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Tags;
